import { useEffect, useState, type FormEvent } from 'react';
import { storeLocalSession } from '../auth';

async function post<T>(url: string, body: unknown): Promise<T> {
  const res = await fetch(`/api/auth${url}`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error ?? `Eroare ${res.status}`);
  return data as T;
}

/** Pagina din linkul primit pe e-mail: activare cont sau resetare parolă. */
export function ActivatePage() {
  const token = new URLSearchParams(window.location.search).get('token') ?? '';
  const [info, setInfo] = useState<{ email: string; displayName: string; purpose: 'invite' | 'reset' } | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [password, setPassword] = useState('');
  const [repeat, setRepeat] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setError('Linkul este incomplet.'); return; }
    post<typeof info>('/link/check', { token }).then(setInfo).catch((e) => setError(e.message));
  }, [token]);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (password !== repeat) { setError('Cele două parole nu coincid.'); return; }
    setBusy(true);
    setError(null);
    try {
      const s = await post<{ token: string; expiresAt: number }>('/link/accept', { token, password });
      storeLocalSession(s.token, s.expiresAt);
      window.location.assign('/');
    } catch (err) {
      setError((err as Error).message);
      setBusy(false);
    }
  }

  return (
    <div className="login-page">
      <img className="login-watermark" src="/logo-mark.png" alt="" aria-hidden="true" />
      <div className="login-card">
        <img className="login-logo" src="/logo.png" alt="Moro Group" />
        {!info && !error && <p className="muted">Se verifică linkul…</p>}
        {info && (
          <form onSubmit={submit} className="login-form">
            <p>{info.purpose === 'invite' ? `Bun venit, ${info.displayName}! Alegeți parola contului.` : 'Alegeți o parolă nouă.'}</p>
            <label>E-mail<input value={info.email} disabled /></label>
            <label>Parolă nouă
              <input type="password" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} required autoFocus />
            </label>
            <label>Repetați parola
              <input type="password" autoComplete="new-password" value={repeat} onChange={(e) => setRepeat(e.target.value)} required />
            </label>
            <p className="muted small">Minimum 10 caractere, cu litere și cifre.</p>
            {error && <p className="error">{error}</p>}
            <button className="accent" type="submit" disabled={busy || !password || !repeat}>
              {busy ? 'Se salvează…' : info.purpose === 'invite' ? 'Activează contul' : 'Salvează parola'}
            </button>
          </form>
        )}
        {!info && error && (
          <>
            <p className="error">{error}</p>
            <a href="/">Mergi la pagina de autentificare</a>
          </>
        )}
      </div>
    </div>
  );
}
